module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("8G46x"))).then(() => module.bundle.root('hEqeo'));